package com.schoolconnect.app.feature.schools

internal fun sanitizeSchoolPhoneInput(value: String): String {
    val trimmed = value.trim()
    val prefix = if (trimmed.startsWith("+")) "+" else ""
    return prefix + trimmed.filter(Char::isDigit).take(15)
}

internal fun isValidSchoolPhoneNumber(value: String): Boolean {
    val normalized = value.trim().filterNot { it.isWhitespace() || it == '-' || it == '(' || it == ')' }
    return normalized.matches(INDIAN_MOBILE_PHONE_REGEX) || normalized.matches(INDIAN_LANDLINE_PHONE_REGEX)
}

private val INDIAN_MOBILE_PHONE_REGEX = Regex("^(?:\\+91|0)?[6-9]\\d{9}$")
private val INDIAN_LANDLINE_PHONE_REGEX = Regex("^(?:0|\\+91)[1-9]\\d{6,12}$")
